<script setup lang="ts">
/**
 * The administrator's message: an outage at the source, a known fault. It comes on top of
 * whatever else is showing, because it is the thing worth reading first, and once clicked
 * away it stays away until the administrator writes a new one.
 */
import { useAppStore } from '../store'

const store = useAppStore()
</script>

<template>
  <div v-if="store.notice" class="modal noticemodal" role="dialog" aria-modal="true" aria-labelledby="notice-title"
       @click.self="store.dismissNotice()">
    <div class="card">
      <h2 id="notice-title">{{ store.t('noticeTitle') }}</h2>
      <p class="noticetext">{{ store.notice.text }}</p>
      <div class="cardbuttons">
        <span></span>
        <button class="primary" @click="store.dismissNotice()">{{ store.t('noticeOk') }}</button>
      </div>
    </div>
  </div>
</template>
